import {
  PainelVendasFilterProps,  CommercialOption
} from "../../../../global/dataTransferObjects/transacoesTempoReal";
import { BaseService } from "../../../../global/classes";
import { buildValueFilter } from "../../shared/valueFilter";
import { bffApi } from "../../../../services/bff/bffApi";
import { createHTMLElement, downloadFile } from "../../../../utils/downloadFiles";

export default class VendaServices extends BaseService {
  private buildSalePayload(filter?: PainelVendasFilterProps, sortBy?: string) {
    return {
      SortBy:               sortBy ?? null,
      InitDate:             filter?.initialDate || null,
      FinishDate:           filter?.finalDate || null,
      Brand:                filter?.bandeira?.length ? [filter.bandeira] : null,
      ProductName:          filter?.tipoPagamento?.length ? filter.tipoPagamento : null,
      Acquirer:             filter?.acquirer != null && filter.acquirer !== -1 ? filter.acquirer : null,
      Capture:              filter?.capture?.length ? filter.capture : null,
      AcquirerNsu:          filter?.acquirerNsu?.length ? filter.acquirerNsu : null,
      BusinessName:         filter?.businessName?.length ? filter.businessName : null,
      MerchantId:           this.selectedCompany
                              ? this.selectedCompany.merchantId
                              : filter?.merchantId?.length ? filter.merchantId : null,
      OrderNumber:          filter?.orderNumber?.length ? filter.orderNumber : null,
      CommercialHierId:     (this.userInfo?.commercialHierId || null) ?? (filter?.commercialHierId ? Number(filter.commercialHierId) : null),
      Status:               filter?.status ?? null,
      CancellationStatus:   filter?.cancellationStatus ?? null,
      TerminalSerialNumber: filter?.serialNumber?.length ? filter.serialNumber : null,
      ParcelMin:            filter?.parcelMin ?? null,
      ParcelMax:            filter?.parcelMax ?? null,
      ValueFilter:          buildValueFilter(filter),
      Email:                this.commercialUserEmail,
      UserType:             this.userInfo?.userType ?? null,
    };
  }

  getVendas = async (
    page: number,
    pageSize: number,
    filter?: PainelVendasFilterProps,
    sortBy?: string
  ) => {
    return bffApi.post(`/api/flux/v1/sales/query-paged`, {
      ...this.buildSalePayload(filter, sortBy),
      PageNumber: page,
      PageSize: pageSize,
    });
  }

  downloadVendas = async (
    type: string,
    filter?: PainelVendasFilterProps,
    sortBy?: string
  ) => {
    const result = await bffApi.post(`/api/flux/v1/sales/download`, {
      ...this.buildSalePayload(filter, sortBy),
      Formato: type,
    }, {
      responseType: 'blob',
    });

    const htmlElement = createHTMLElement(result.data);
    downloadFile(htmlElement, 'PainelDeVendas', type);
  }

  getCommercialOptions = async (): Promise<CommercialOption[]> => {
    const result = await bffApi.get(`/api/struct/v1/outbound/commercial-options`);
    return result.data;
  }
}
